var exports = {
  "nM": "AccountTab.module__row___QVJsRz",
  "Db": "AccountTab.module__accountRows___QVJsRz",
  "u4": "AccountTab.module__rowContent___QVJsRz",
  "Pf": "AccountTab.module__label___QVJsRz",
  "h_": "AccountTab.module__description___QVJsRz",
  "vF": "AccountTab.module__emailRow___QVJsRz",
  "c1": "AccountTab.module__emailText___QVJsRz",
  "aO": "AccountTab.module__emailTextSelectable___QVJsRz",
  "Rm": "AccountTab.module__toggleButton___QVJsRz",
  "i4": "AccountTab.module__warningText___QVJsRz",
  "yF": "AccountTab.module__divider___QVJsRz",
  "Hk": "AccountTab.module__claimButton___QVJsRz",
};

module.exports = exports;
